var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQueryClient, } from "@tanstack/react-query";
import { useAccountSummaryV2Query as useAccountSummaryQuery, } from "@syf-api-library/account-summary";
import { useCreditAccountsQuery, } from "@syf-api-library/credit-accounts";
import { profileDetailsCacheKey, useMultiProfileMutation, useProfileQuery, useProfileScopeQuery, } from "@syf-api-library/profile";
import getApiConfig from "../helpers/getApiConfig";
var useCreditAccounts = function (config, queryOptions) {
    var queryClient = useQueryClient();
    var enabledQuery = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getApiConfig(queryClient, config, enabledQuery, queryOptions);
    return useCreditAccountsQuery(__assign({}, apiConfig));
};
var useAccountSummary = function (accountId, config) {
    var queryClient = useQueryClient();
    var apiConfig = getApiConfig(queryClient, config, Boolean(accountId));
    return useAccountSummaryQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useProfile = function (accountId, config) {
    var queryClient = useQueryClient();
    var apiConfig = getApiConfig(queryClient, config, Boolean(accountId));
    return useProfileQuery(__assign({ keyProps: { accountId: accountId, accountIdType: "guid" } }, apiConfig));
};
var useProfileScope = function (accountId, config) {
    var queryClient = useQueryClient();
    var apiConfig = getApiConfig(queryClient, config, Boolean(accountId));
    return useProfileScopeQuery(__assign({ keyProps: {
            accountId: accountId,
            accountIdType: "guid",
        } }, apiConfig));
};
var useMultiProfileUpdate = function (config, accountId) {
    var queryClient = useQueryClient();
    var enabledMutation = Boolean(sessionStorage.getItem("accessToken"));
    var apiConfig = getApiConfig(queryClient, config, enabledMutation);
    var profileCacheKey = profileDetailsCacheKey({
        accountId: accountId,
        accountIdType: "guid",
    });
    return useMultiProfileMutation(__assign(__assign({ keyProps: undefined }, apiConfig), { mutationOptions: {
            onSuccess: function () {
                setTimeout(function () { return queryClient.invalidateQueries(profileCacheKey); }, 500);
            },
        } }));
};
export var CREDIT_HEALTH_QUERY_KEY = "credit-health-";
export { useAccountSummary, useCreditAccounts, useMultiProfileUpdate, useProfile, useProfileScope, };
